/**
 * 非首屏关键任务：DOMContentLoaded 后再跑，避免与解析/首屏抢主线程。
 * 已 interactive 时立即调度（仍异步，不挡当前调用栈）。
 */
export const runAfterDomReady = (task: () => void): void => {
  const run = () => {
    // 再让出一帧，优先保证首屏 paint
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => {
        setTimeout(task, 0);
      });
    } else {
      setTimeout(task, 0);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
};

/** idle 优先；超时兜底，适合监控等可再晚一点的任务 */
export const runWhenIdle = (task: () => void, timeout = 3000): void => {
  const schedule = () => {
    const ric = (window as any).requestIdleCallback as
      | ((cb: () => void, opts?: { timeout: number }) => number)
      | undefined;
    if (typeof ric === 'function') {
      ric(task, { timeout });
    } else {
      setTimeout(task, 0);
    }
  };
  runAfterDomReady(schedule);
};
